module.exports = __webpack_public_path__ + "static/img/about1.28e2539.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/about1.png
// module id = GLa8
// module chunks = 1